import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import 'es6-promise/auto';
import Ua from './components/modules/ua';

if(!Ua.isValidUa(navigator.userAgent)) {
    alert("お使いのブラウザではご利用いただけません。");
}

ReactDOM.render(<App/>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js